import { useState, useEffect } from 'react';
import { userInfoAtom } from '../../data/atoms/utilsAtoms';
import { useAtomValue } from 'jotai';
import { useNavigate } from 'react-router-dom';
import Facebook from '../Facebook';
import { userPlans, studioPlans, userVIPPlans } from '../../data/utils/plans';
import React from 'react';
import { getAllTrackingIds, persistMetaCookiesToStorage } from '@/utils/metaCookies';  // NEW IMPORT

const ChargebeeButton = ({ planType, seats, newlySignedUp, isStudio, isVIP }) => {
  const [isVisible, setIsVisible] = useState(false);
  const userData = useAtomValue(userInfoAtom);
  const navigate = useNavigate();

  const plans = isStudio ? studioPlans : isVIP ? userVIPPlans : userPlans;

  const selectedPlan = isStudio
    ? plans.find(plan => plan.seats === seats)
    : plans.find(plan => plan.param === planType);

  console.log(selectedPlan?.cbItem);
  console.log('isStudio condition', isStudio);

  const handleChargebeeClick = (type, isStudio) => {
    if (userData.token == null) {
      localStorage.clear();
    }

    if (userData.token != null || newlySignedUp) {
      window.Chargebee.registerAgain();
      
      // Track custom event (existing)
      window?.fbq('trackCustom', selectedPlan.id, {
        CustomEvent: selectedPlan.id
      });
      
      // NEW: Also fire standard StartTrial event for better Meta tracking
      window?.fbq('track', 'StartTrial', {
        content_name: selectedPlan.id,
        content_category: 'subscription',
        currency: 'USD',
        value: 0
      });
      
      // NEW: Persist Meta cookies for later use
      persistMetaCookiesToStorage();
      
    } else {
      if (isStudio) {
        navigate('/StudioSignUp');
      } else {
        navigate(`/signup`);
      }
    }
  };

  const navigateToSignUpPage = () => {
    if (isStudio) {
      navigate('/StudioSignUp');
    } else {
      navigate(`/signup`);
    }
  };

  // Delay rendering by 1.5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1500);

    return () => clearTimeout(timer); // Cleanup on component unmount
  }, []);

  if (!isVisible) {
    return null; // Render nothing until 1.5 seconds have passed
  }

  if (!userData.token || !userData.user?.email) {
    return (
      <React.Fragment>
        <button id={selectedPlan.id} style={{ width: '100%' }} onClick={() => navigateToSignUpPage()}>
          {!isStudio ? <div>FREE {selectedPlan.days} DAY TRIAL</div> : <div>Get your plan</div>}
        </button>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <Facebook />
      {userData.user?.isTrialAvailed ? (
        <React.Fragment>
          <button
            className="c-form_my-btn"
            data-cb-type="portal"
            onClick={() => {
              window.Chargebee.registerAgain();
              const testInstance = window?.Chargebee?.getInstance();
              const cart = testInstance?.getCart();
              console.log(cart);

              // Build customer details
              const customerDetails = {
                id: userData.user?.email ? userData.user?.email : '',
                email: userData.user?.email ? userData.user?.email.toLowerCase() : '',
                first_name: userData.user?.firstname,
                last_name: userData.user?.lastname
              };

              const trackingIds = getAllTrackingIds();
              Object.assign(customerDetails, trackingIds);

              cart.setCustomer(customerDetails);
            }}
          >
            MANAGE SUBSCRIPTION
          </button>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <button
            id={selectedPlan.id}
            style={{ width: '100%' }}
            data-cb-type="checkout"
            data-cb-item-0={selectedPlan.cbItem}
            onClick={() => handleChargebeeClick(planType, isStudio)}
          >
            {!isStudio ? <div>FREE {selectedPlan.days} DAY TRIAL</div> : <div>Get your plan</div>}
          </button>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default ChargebeeButton;
